import { useQuery } from "@apollo/client";

import { gql } from "~/__generated__";

const CLIENT_GET_ALL_ROLES = gql(`
    query ClientGetAllRoles {
        clientGetAllRoles {
            id
            name
        }
    }
`);

export default function useClientUserGetAllRoles() {
    const { data, loading, error } = useQuery(CLIENT_GET_ALL_ROLES, {
        errorPolicy: "all",
    });

    return {
        allRoles: data?.clientGetAllRoles ?? [],
        loading,
        error,
    };
}
